import StarringYouCards from "components/StarringYouCards";
import CategoryHeader from "components/CategoryHeader";
import Banner from "components/Banner";

const LoadingSkeleton = () => {
  return (
    <>
      <CategoryHeader loading />
      <Banner loading />
      <StarringYouCards loading />
    </>
  );
};

export default LoadingSkeleton;
